import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import { getPaginator } from '@orange-marmalade/paginate-this';
import cx from 'classnames';
import { compact, range } from 'underscore';
import numeral from 'numeral';
import { Link } from 'react-router-dom';
import URI from 'urijs';

// modules
import styles from '../Containers.module.scss';
import BS from '../../theme/Bootstrap';

// images
import notfound from '../../partials/property-card/images/notfound.png';
import agent_notfound from '../../partials/agent-card/images/notfound.png';

const PHOTO_BASE_URL = process.env.REACT_APP_PHOTO_LARGE_URL;
const AGENT_PHOTO_BASE_URL = '//memberphotos.naplesarea.com/';

function PropertyResultsTable({
  listId,
  results,
  placeholderImg = notfound,
  propertyClass = 'residential',
  totalCount,
  isLoading,
  pathname
}) {
  const numPerPage = 10;
  const numPages = Math.ceil(results.length / numPerPage);
  const isRental = propertyClass === 'rental';
  const isCommercial = propertyClass === 'commercial';
  const isResidential = propertyClass === 'residential';
  // const isLand = propertyClass === 'land';

  if (totalCount === 0 && !isLoading) {
    return <div className={BS.textCenter}>No Favorites</div>;
  }

  return (
    <Table className={cx(styles.compareTable, BS.tableResponsive)}>
      {range(numPages).map(page => {
        const innerResults = results.slice(page * numPerPage, (page + 1) * numPerPage);
        return (
          <tbody key={page}>
            <tr>
              <th />
              {innerResults.map((data, i) => (
                <td key={i} className={styles.img}>
                  <Link
                    to={URI(`/property-detail/${data.mlsNumber}-${propertyClass}`)
                      .search({
                        searchURI: pathname
                      })
                      .toString()}
                  >
                    <img
                      src={
                        data.photoPath ? PHOTO_BASE_URL + data.photoPath : placeholderImg
                      }
                      alt="Property"
                      onError={e => {
                        e.target.src = placeholderImg;
                        e.target.className = cx(e.target.className, BS.b1);
                      }}
                      className={cx({
                        [BS.b1]: !data.photoPath
                      })}
                    />
                  </Link>
                </td>
              ))}
            </tr>
            <tr>
              <th>Address</th>
              {innerResults.map((data, i) => {
                const address = compact([
                  (data.fullAddress || '').trim(),
                  (data.city || '').trim(),
                  compact([
                    (data.stateOrProvince || '').trim(),
                    (data.postalCode || '').trim()
                  ]).join(' ')
                ]).join(', ');
                return (
                  <td key={i} className={styles.address}>
                    <Link
                      to={URI(`/property-detail/${data.mlsNumber}-${propertyClass}`)
                        .search({
                          searchURI: pathname
                        })
                        .toString()}
                    >
                      {address}
                    </Link>
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>MLS#</th>
              {innerResults.map((data, i) => (
                <td key={i} className={styles.mlsNumber}>
                  {data.mlsNumber}
                </td>
              ))}
            </tr>
            <tr>
              <th>Status</th>
              {innerResults.map((data, i) => (
                <td key={i} className={styles.status}>
                  {data.status}
                </td>
              ))}
            </tr>
            {isRental && (
              <tr>
                <th>PriceRENT</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.price}>
                    {getPrice(data)}
                  </td>
                ))}
              </tr>
            )}
            {!isRental && (
              <tr>
                <th>Price</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.price}>
                    {getPrice(data)}
                  </td>
                ))}
              </tr>
            )}
            {!isCommercial && (
              <tr>
                <th>Sub/Condo</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.subCondo}>
                    {data.condoName}
                  </td>
                ))}
              </tr>
            )}
            {!isCommercial && (
              <tr>
                <th>Development</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.development}>
                    {data.development}
                  </td>
                ))}
              </tr>
            )}
            {(isRental || isResidential) && (
              <tr>
                <th>Beds</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.beds}>
                    {data.bedrooms}
                  </td>
                ))}
              </tr>
            )}
            {(isRental || isResidential) && (
              <tr>
                <th>Baths</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.baths}>
                    {getBathString(data)}
                  </td>
                ))}
              </tr>
            )}
            {(isRental || isResidential) && (
              <tr>
                <th>Living Area</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.baths}>
                    {numeral(data.livingArea).format('0,0')} sqft
                  </td>
                ))}
              </tr>
            )}
            {(isRental || isResidential) && (
              <tr>
                <th>Private Pool</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.privatePool}>
                    {data.privatePool ? 'Yes' : 'No'}
                  </td>
                ))}
              </tr>
            )}

            {!isCommercial && (
              <tr>
                <th>Waterfront</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.waterfront}>
                    {(data.waterfront || '').trim().split(',').join(', ')}
                  </td>
                ))}
              </tr>
            )}
            {!isCommercial && (
              <tr>
                <th>View</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.view}>
                    {(data.view || '').trim().split(',').join(', ')}
                  </td>
                ))}
              </tr>
            )}
            {(isRental || isResidential) && (
              <tr>
                <th>Design</th>
                {innerResults.map((data, i) => (
                  <td key={i} className={styles.design}>
                    {(data.bldgDesign || '').trim().split(',').join(', ')}
                  </td>
                ))}
              </tr>
            )}
            <tr>
              <th>Listing Agent</th>
              {innerResults.map((data, i) => (
                <td key={i} className={styles.agent}>
                  <div>{data.listAgentFullName}</div>
                  <img
                    alt={
                      data.displayAgent ? data.displayAgent.displayType : 'Listing Agent'
                    }
                    src={
                      data.displayAgent && data.displayAgent.photo
                        ? AGENT_PHOTO_BASE_URL + data.displayAgent.photo
                        : agent_notfound
                    }
                    className={cx({
                      [BS.b1]: !(data.displayAgent && data.displayAgent.photo)
                    })}
                    onError={e => {
                      e.target.src = agent_notfound;
                      e.target.className = cx(e.target.className, BS.b1);
                    }}
                  />
                </td>
              ))}
            </tr>
            <tr>
              <th>Listing Firm</th>
              {innerResults.map((data, i) => (
                <td key={i} className={styles.office}>
                  <div>{data.listOfficeName}</div>
                </td>
              ))}
            </tr>
          </tbody>
        );
      })}
    </Table>
  );
}

function getBathString(data) {
  var str = `${data.bathsFull || 0} (${data.bathsHalf || 0})`;
  return str;
}

function getPrice(data) {
  var price = data.currentPrice,
    label = '';

  if (data.propertyClass === 'rental') {
    if (data.availabilityType.indexOf('Annual') !== -1) {
      price = data.monthlyRate;
      label = ' / Month';
    } else if (data.availabilityType.indexOf('Seasonal') !== -1) {
      price = data.seasonRate;
      label = ' / Month';
    } else if (data.availabilityType.indexOf('Off-Season') !== -1) {
      price = data.offSeasonRate;
      label = ' / Month';
    }
  }

  return `${numeral(price).format('$0,0')}${label}`;
}

export default connect((state, props) => {
  const paginator = getPaginator(props.listId, state);
  const { pathname } = state.routing.location;
  return {
    results: paginator.get('results').toJS(),
    totalCount: paginator.get('totalCount'),
    isLoading: paginator.get('isLoading'),
    pathname
  };
}, {})(PropertyResultsTable);



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/PropertyResultsTable.js